import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';
import { ApiService } from '../api.services';
import { HttpParams } from '@angular/common/http';
import { Package, PackageRequest } from '../../../models/package.model';

@Injectable({
    providedIn: 'root'
})

export class PackageService {

    private baseUrl: string = superAdminHttpVersion.V1;

    constructor(private apiService: ApiService) { }

    filter(q: string, page_number?: number, page_size?: number): Observable<any> {
        let params = new HttpParams();
        params = params.set('q', q);
        if (page_number) {
            params = params.set('page_number', page_number);
        }
        if (page_size) {
            params = params.set('page_size', page_size);
        }
        return this.apiService.httpGetCall(`${this.baseUrl}${superAdminHttpRoutes.PLAN_GET_TABLE}`, params);
    }

    registerPackage(_package: PackageRequest): Observable<any> {
        return this.apiService.httpPostCall(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}`, _package)
    }

    getOnePackage(_packageId: string): Observable<any> {
        return this.apiService.httpGetCallWithoutParameter(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}/${_packageId}`)
    }

    updatePackage(packageId: any, _package: PackageRequest): Observable<any> {
        return this.apiService.httpPutCall(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}/${packageId}`, _package)
    }

    deactivate(packageId: string): Observable<any> {
        return this.apiService.httpPatchCall(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}/${packageId}/status `, {
            "status": "Inactive"
        });
    }

    activate(packageId: string): Observable<any> {
        return this.apiService.httpPatchCall(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}/${packageId}/status`, {
            "status": "Active"
        });
    }

    getAllPlans(): Observable<any> {
        return this.apiService.httpGetCallWithoutParameter(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}`);
    }
    getAllProducts(): Observable<any> {
        return this.apiService.httpGetCallWithoutParameter(`${this.baseUrl}${superAdminHttpRoutes.GET_PRODUCT}`);
    }

    updatePackagePosition(_id: string, order: number) {
        const requestBody = {
            _id: _id,
            order: order
        };
        return this.apiService.httpPatchCall<Package>(`${this.baseUrl}${superAdminHttpRoutes.MODIFY_PLAN_POSITION}`, requestBody);
    }

    companyCheck(payload: any) {
        return this.apiService.httpPatchCallWithoutToken<Package>(`${this.baseUrl}${superAdminHttpRoutes.CHECK_COMPANY}`, payload);
    }

    companyCreate(payload: any) {
        return this.apiService.httpPostCallWithoutToken<Package>(`${this.baseUrl}${superAdminHttpRoutes.CREATE_COMPANY}`, payload);
    }

    companyRegistration(payload: any) {
        return this.apiService.httpPostCallWithoutToken<Package>(`${this.baseUrl}${superAdminHttpRoutes.REGISTRATION_COMPANY}`, payload);
    }

    uploadPackageImage(file: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("bucketName", "sos-superadmin-portal");
        formData.append("dirPath", `packages`);

        return this.apiService.httpPostCall<any>(
            `${this.baseUrl}${superAdminHttpRoutes.UPLOAD_PRODUCT_LOGO}`,
            formData
        );
    }

    getPackageCourses(_packageId: string): Observable<any> {
        return this.apiService.httpGetCallWithoutParameter(`${this.baseUrl}${superAdminHttpRoutes.PLAN_ADD_EDIT}/${_packageId}/courses`)
    }
}